// AI-rådgiver — rapportgenerering (no).
window.PlummeI18n.register('no', {
  'adv.cf.cashBasisMissing': 'Kontantgrunnlaget er ikke tilgjengelig. Saldo og bevegelser må kunne avstemmes mot hovedboken.',
  'adv.cf.cashBalanceEvidence': 'Bokført kontant- og banksaldo er {amount}. Dette er ikke en bankbekreftet saldo.',
  'adv.rpt.period.profit': 'I {quarter}. kvartal {year} er inntektene {income} og overskuddet {result}.',
  'adv.rpt.period.loss': 'I {quarter}. kvartal {year} er inntektene {income} og underskuddet {result}.',
  'adv.rpt.period.nativeSuppliers': 'Leverandørlisten gjelder daterte kjøp i kvartalet, uten anleggsmidler og importerte årsoppsummeringer uten kvartalsfordeling.',
  "adv.rpt.period.choose": "Periode",
  "adv.rpt.period.year": "Hele året",
  "adv.rpt.period.yearLabel": "Hele {year}",
  "adv.rpt.period.quarter": "{quarter}. kvartal",
  "adv.rpt.period.label": "{quarter}. kvartal {year}",
  "adv.rpt.period.vsQuarter": "mot samme kvartal året før",
  "adv.rpt.period.quarterBasis": "Regnskapstall for {from}–{to}. Balanse viser saldo ved periodens slutt.",
  "adv.rpt.period.currentStatus": "Oppfølgingsstatus ved rapportgenerering {date}. Denne delen bruker dagens åpne poster og årsoversikt, ikke historisk status ved kvartalsslutt.",
  "adv.rpt.period.rolling": "Rullerende 12 måneder frem til {to}, sammenlignet med de foregående 12 månedene.",
  "adv.rpt.period.nativeSales": "Kunde- og fakturadetaljer gjelder bokførte fakturaer med dato i kvartalet. Importerte årsoppsummeringer uten kvartalsfordeling er ikke med her.",
  "adv.rpt.period.budget": "Bokført i valgt kvartal sammenlignes med budsjettet for de samme tre månedene.",
  "adv.rpt.period.pdfUnavailable": "Den nye PDF-utformingen er ikke tilgjengelig på serveren ennå. Prøv igjen etter oppdateringen.",
  "adv.rpt.slides.present": "Presenter",
  "adv.rpt.slides.exit": "Avslutt presentasjon",
  "adv.rpt.slides.readable": "Les sidens tekst",
  "adv.rpt.slides.previous": "Tilbake",
  "adv.rpt.slides.next": "Neste",
  "adv.rpt.slides.page": "Side {current} av {total}",
  // ------------------------------------------------------------ Malvelgeren
  'adv.rpt.modal.title': 'Lag rapport',
  'adv.rpt.modal.intro': 'Velg en rapportmal. SuperPlumma henter tallene fra regnskapet ditt og setter sammen et utkast du kan gå gjennom før den deles.',
  'adv.rpt.modal.generate': 'Generer rapport',
  'adv.rpt.modal.cancel': 'Avbryt',
  'adv.rpt.modal.basis': 'Datagrunnlag: {sources}',
  'adv.rpt.modal.year': 'Regnskapsår',
  'adv.rpt.modal.saved': 'Lagrede rapporter',
  'adv.rpt.modal.savedEmpty': 'Du har ingen lagrede rapporter ennå.',
  'adv.rpt.modal.open': 'Åpne',
  'adv.rpt.modal.delete': 'Slett',
  'adv.rpt.modal.deleted': 'Rapporten er slettet.',
  'adv.rpt.hero.cta': 'Lag rapport',
  'adv.rpt.saved.title': 'Lagrede rapporter',
  'adv.rpt.saved.tab': 'Lagrede rapporter',
  'adv.rpt.saved.description': 'Rapporter du lagrer, blir liggende som øyeblikksbilder og endres ikke når regnskapet oppdateres.',
  'adv.rpt.saved.count': '{count} av {limit} rapporter lagret',
  'adv.rpt.saved.limitError': 'Du kan lagre maksimalt {limit} rapporter. Slett en rapport før du lagrer en ny.',
  'adv.rpt.saved.loading': 'Henter lagrede rapporter …',
  'adv.rpt.saved.emptyTitle': 'Ingen lagrede rapporter',
  'adv.rpt.saved.emptyText': 'Lag en rapport og lagre den når du vil beholde akkurat denne versjonen.',
  'adv.rpt.saved.loadFailed': 'Kunne ikke hente lagrede rapporter.',
  'adv.rpt.saved.deleteFailed': 'Kunne ikke slette rapporten.',

  // ------------------------------------------------------------ Maler
  'adv.rpt.tpl.styre.name': 'Styre- og ledelsesrapport',
  'adv.rpt.tpl.styre.desc': 'Helhetlig rapport til styret med resultat, likviditet, risiko og anbefalte tiltak.',
  'adv.rpt.tpl.manedsrapport.name': 'Månedsrapport',
  'adv.rpt.tpl.manedsrapport.desc': 'Status for valgt måned med budsjett, fjorårssammenligning, trend og anbefalte neste steg.',
  'adv.rpt.tpl.likviditet.name': 'Likviditetsrapport',
  'adv.rpt.tpl.likviditet.desc': 'Åpne poster, buffer og løpende saldo basert på bokførte tall.',
  'adv.rpt.tpl.avvik.name': 'Resultat- og avviksrapport',
  'adv.rpt.tpl.avvik.desc': 'De største avvikene mot budsjett hittil i år, og kostnadslinjene som har endret seg mest.',
  'adv.rpt.tpl.kunde.name': 'Kunde- og salgsrapport',
  'adv.rpt.tpl.kunde.desc': 'Salgsutvikling, største kunder, kundekonsentrasjon og utestående.',
  'adv.rpt.tpl.kostnad.name': 'Kostnadsrapport',
  'adv.rpt.tpl.kostnad.desc': 'Kostnadsutvikling, de største leverandørene og bilag som mangler dokumentasjon.',
  'adv.rpt.tpl.utestaende.name': 'Utestående poster',
  'adv.rpt.tpl.utestaende.desc': 'Ubetalte kunde- og leverandørposter fordelt på forfalt og ikke forfalt.',
  'adv.rpt.tpl.arsoppsummering.name': 'Årsoppsummering',
  'adv.rpt.tpl.arsoppsummering.desc': 'Oppsummerer hele året — resultat, balanse, salg, kostnader og risiko.',

  'adv.rpt.length.2to3': '2–3 sider',
  'adv.rpt.length.2to4': '2–4 sider',
  'adv.rpt.length.3to5': '3–5 sider',
  'adv.rpt.length.4to6': '4–6 sider',
  'adv.rpt.length.8to12': '8–12 sider',
  'adv.rpt.length.variable': 'Omfang følger datagrunnlaget',
  'adv.rpt.length.10to14': '10–14 sider',

  // ------------------------------------------------------------ Dokumentet
  'adv.rpt.doc.contents': 'Innhold',
  'adv.rpt.doc.brand': 'PLUMME / AI RÅDGIVER',
  'adv.rpt.doc.continued': 'forts.',
  'adv.rpt.doc.back': 'Tilbake',
  'adv.rpt.doc.draft': 'Utkast',
  'adv.rpt.doc.saved': 'Lagret',
  'adv.rpt.doc.save': 'Lagre',
  'adv.rpt.doc.savedToast': 'Rapporten er lagret.',
  'adv.rpt.doc.exportPdf': 'Eksporter PDF',
  'adv.rpt.doc.exportPptx': 'Last ned PowerPoint',
  'adv.rpt.doc.exportingPptx': 'Bygger PowerPoint …',
  'adv.rpt.doc.exportPptxFailed': 'Kunne ikke lage PowerPoint-filen. Prøv igjen.',
  'adv.rpt.doc.presentation': 'PRESENTASJON',
  'adv.rpt.doc.coverFoot': 'Generert fra rapportgrunnlaget i Plumme',
  'adv.rpt.doc.exporting': 'Lager PDF …',
  'adv.rpt.doc.exportFailed': 'Klarte ikke å lage rapportfilen. Prøv igjen.',
  'adv.rpt.doc.period': '{year} · {months} måneder av året',
  'adv.rpt.doc.createTask': 'Opprett oppgave',
  'adv.rpt.doc.taskCreated': 'Lagt i handlingssenteret med oppfølging {date}.',
  'adv.rpt.doc.taskFailed': 'Klarte ikke å opprette oppgaven.',
  'adv.rpt.doc.taskNote': 'Opprettet fra {report}.',

  // ------------------------------------------------------------ Narrativ (AI)
  'adv.rpt.narr.section': 'Sammendrag fra SuperPlumma',
  'adv.rpt.narr.tag': 'Skrevet av SuperPlumma',
  'adv.rpt.narr.idle': 'La SuperPlumma lese rapporten og skrive sammendraget: hva som står på spill, hva som faktisk beveget seg, og hva du bør gjøre nå.',
  'adv.rpt.narr.write': 'Skriv sammendrag',
  'adv.rpt.narr.rewrite': 'Skriv på nytt',
  'adv.rpt.narr.loading': 'SuperPlumma leser rapporten …',
  'adv.rpt.narr.failed': 'Klarte ikke å skrive sammendraget. Tallene i rapporten er uansett komplette.',
  'adv.rpt.narr.drivers': 'Dette beveget seg',
  'adv.rpt.narr.watch': 'Dette bør følges',
  'adv.rpt.narr.nextStep': 'Neste steg: ',
  'adv.rpt.narr.foot': 'Sammendraget er skrevet ut fra tallene i rapporten. Alle beløp er kontrollert mot rapporten før teksten vises.',

  // ------------------------------------------------------------ Seksjoner
  'adv.rpt.sec.changeSince': 'Endringer siden forrige rapport',
  'adv.rpt.col.lastReport': 'Forrige rapport',
  'adv.rpt.col.now': 'Nå',
  'adv.rpt.col.change': 'Endring',
  'adv.rpt.note.changeSinceBasis': 'Sammenlignet med rapporten som ble lagret {date}. Tallene der er et øyeblikksbilde og endrer seg ikke i ettertid.',
  'adv.rpt.empty.noPreviousReport': 'Dette er den første lagrede rapporten av denne typen for året. Neste gang viser denne seksjonen hva som er endret siden nå.',
  'adv.rpt.empty.noComparableReport': 'Forrige rapport har ingen hovedtall å sammenligne mot.',
  'adv.rpt.sec.summary': 'Sammendrag',
  'adv.rpt.sec.events': 'Vesentlige hendelser',
  'adv.rpt.sec.keyFigures': 'Økonomiske hovedtall',
  'adv.rpt.sec.budget': 'Resultat mot budsjett',
  'adv.rpt.sec.liquidity': 'Likviditet og betalingsforpliktelser',
  'adv.rpt.sec.forecast': 'Løpende saldo gjennom året',
  'adv.rpt.sec.balance': 'Balanse og soliditet',
  'adv.rpt.sec.resultTrend': 'Resultatutvikling',
  'adv.rpt.sec.sales': 'Salg og kundeutvikling',
  'adv.rpt.sec.customerChange': 'Kundelojalitet og betalingstid',
  'adv.rpt.sec.costTrend': 'Kostnadsutvikling',
  'adv.rpt.sec.suppliers': 'Største leverandører',
  'adv.rpt.sec.voucherReview': 'Bilag til gjennomgang',
  'adv.rpt.sec.receivables': 'Kundeposter',
  'adv.rpt.sec.payables': 'Leverandørposter',
  'adv.rpt.sec.risk': 'Risiko og usikkerhet',
  'adv.rpt.sec.actions': 'Anbefalte tiltak',
  'adv.rpt.sec.decisions': 'Saker til beslutning',
  'adv.rpt.sec.dataBasis': 'Datagrunnlag',

  // ------------------------------------------------------------ Analyse (nivå 2)
  'adv.rpt.sec.bridge': 'Hva flyttet resultatet',
  'adv.rpt.sec.workingCapital': 'Arbeidskapital og bindingstid',
  'adv.rpt.sec.rolling': 'Rullerende 12 måneder',
  'adv.rpt.col.driver': 'Driver',
  'adv.rpt.col.effect': 'Effekt',
  'adv.rpt.col.priority': 'Prioritet',
  'adv.rpt.bridge.opening': 'Resultat {year}',
  'adv.rpt.bridge.closing': 'Resultat {year}',
  'adv.rpt.bridge.revenue': 'Endring i inntekter',
  'adv.rpt.bridge.finance': 'Endring i finansposter',
  'adv.rpt.bridge.other': 'Øvrige poster ({count} linjer)',
  'adv.rpt.bridge.readGuide': 'Les fra venstre: Start med fjorårets resultat. Grønt løfter resultatet, rødt trekker det ned. Siste stolpe er årets resultat. Beløpene under viser hvert bidrag.',
  'adv.rpt.bridge.readShort': 'Fra fjoråret til i år · Grønt løfter resultatet · Rødt trekker ned',
  'adv.rpt.note.bridgeBasis': 'Linjer med effekt under {amount} er slått sammen. Broen går fra resultatet i {year} til resultatet i år, og summen av driverne er hele endringen.',
  'adv.rpt.empty.noBridgeBasis': 'Uten bokførte tall for {year} kan ikke endringen brytes ned på drivere.',
  'adv.rpt.empty.noBridgeChange': 'Resultatet er uendret fra {year}.',
  'adv.rpt.metric.receivableDays': 'Kundefordringer',
  'adv.rpt.metric.payableDays': 'Leverandørgjeld',
  'adv.rpt.metric.capitalGap': 'Bindingstid netto',
  'adv.rpt.metric.measuredPaymentDays': 'Faktisk betalingstid',
  'adv.rpt.metric.netCapitalTied': 'Netto bundet kapital',
  'adv.rpt.note.capitalGapPositive': 'Du venter {days} dager lenger på pengene enn du selv bruker på å betale. Det er den perioden driften må finansieres av egen kasse.',
  'adv.rpt.note.capitalGapNegative': 'Du betaler senere enn du får betalt. Leverandørkreditt finansierer da deler av driften.',
  'adv.rpt.note.capitalGapUnknown': 'Netto bindingstid kan ikke beregnes fordi inntekts- eller kostnadsgrunnlaget mangler.',
  'adv.rpt.note.workingCapitalBasis': 'Fordrings- og leverandørdagene er anslag basert på åpne poster og {months} måneder av rapportåret. Faktisk betalingstid måles bare på betalte kundefakturaer og er derfor ikke samme beregning.',
  'adv.rpt.empty.noWorkingCapital': 'Ingen åpne kunde- eller leverandørposter å måle bindingstid på.',
  'adv.rpt.cell.vsPrevious12': 'mot forrige 12',
  'adv.rpt.note.rollingBasis': 'Vinduet er de siste {months} bokførte månedene, så sammenligningen krysser årsskiftet og rammes ikke av sesong.',
  'adv.rpt.note.noRollingComparison': 'Det finnes ikke nok historikk til å sammenligne mot de foregående 12 månedene.',
  'adv.rpt.empty.noRollingBasis': 'For lite bokført historikk til å bygge et rullerende 12-månedersvindu.',
  'adv.rpt.certainty.planned': 'Planlagt',

  // ------------------------------------------------------------ Sammendrag
  'adv.rpt.summary.profit': 'Etter {months} måneder av {year} er det bokført {income} i inntekter og et overskudd på {result}.',
  'adv.rpt.summary.loss': 'Etter {months} måneder av {year} er det bokført {income} i inntekter og et underskudd på {result}.',
  'adv.rpt.summary.margin': 'Det gir en resultatmargin på {margin} %.',

  // ------------------------------------------------------------ Nøkkeltall
  'adv.rpt.kpi.income': 'Inntekter',
  'adv.rpt.kpi.costs': 'Kostnader',
  'adv.rpt.kpi.result': 'Resultat',
  'adv.rpt.kpi.margin': 'Resultatmargin',
  'adv.rpt.kpi.revenue': 'Fakturert salg',
  'adv.rpt.kpi.invoiceCount': 'Antall fakturaer',
  'adv.rpt.kpi.avgInvoice': 'Snitt per faktura',
  'adv.rpt.kpi.customerCount': 'Antall kunder',

  'adv.rpt.metric.receivables': 'Utestående fra kunder',
  'adv.rpt.metric.payables': 'Skyldig til leverandører',
  'adv.rpt.metric.buffer': 'Likviditetsbuffer',
  'adv.rpt.metric.lowestBalance': 'Laveste saldo i året',
  'adv.rpt.metric.assets': 'Sum eiendeler',
  'adv.rpt.metric.equityAndDebt': 'Sum egenkapital og gjeld',
  'adv.rpt.metric.solidity': 'Egenkapitalandel',
  'adv.rpt.metric.repeatRate': 'Andel gjenkjøpskunder',
  'adv.rpt.metric.avgPaymentDays': 'Snitt betalingstid',
  'adv.rpt.unit.days': '{days} dager',

  // ------------------------------------------------------------ Tabeller
  'adv.rpt.col.line': 'Linje',
  'adv.rpt.col.account': 'Konto',
  'adv.rpt.col.budgetToDate': 'Budsjett hittil',
  'adv.rpt.col.actual': 'Bokført',
  'adv.rpt.col.variance': 'Avvik',
  'adv.rpt.col.month': 'Måned',
  'adv.rpt.col.in': 'Inn',
  'adv.rpt.col.out': 'Ut',
  'adv.rpt.col.balance': 'Saldo',
  'adv.rpt.col.certainty': 'Grunnlag',
  'adv.rpt.col.income': 'Inntekter',
  'adv.rpt.col.costs': 'Kostnader',
  'adv.rpt.col.result': 'Resultat',
  'adv.rpt.col.share': 'Andel',
  'adv.rpt.chart.budgetActual': 'Budsjett mot bokført hittil',
  'adv.rpt.chart.monthlyResult': 'Resultat per måned',
  'adv.rpt.chart.incomeCosts': 'Inntekter og kostnader per måned',
  'adv.rpt.chart.summaryResult': 'Fra inntekter til resultat',
  'adv.rpt.chart.keyFiguresComparison': 'Hovedtall mot fjoråret',
  'adv.rpt.chart.previousPeriod': 'Forrige periode',
  'adv.rpt.chart.currentPeriod': 'Denne perioden',
  'adv.rpt.chart.cumulativeResult': 'Akkumulert resultat gjennom året',
  'adv.rpt.chart.runningBalance': 'Løpende saldo og likviditetsbuffer',
  'adv.rpt.chart.openItemsDue': 'Åpne poster etter forfall',
  'adv.rpt.chart.workingCapitalGap': 'Kapital bundet i åpne poster',
  'adv.rpt.chart.balanceBasis': 'Bokførte balansegrupper',
  'adv.rpt.chart.bookedBalance': 'Bokført saldo',
  'adv.rpt.chart.capitalStructure': 'Kapitalstruktur',
  'adv.rpt.chart.equityShare': 'Egenkapital',
  'adv.rpt.chart.otherFinancing': 'Annen finansiering',
  'adv.rpt.chart.profit': 'Overskudd',
  'adv.rpt.chart.loss': 'Underskudd',
  'adv.rpt.col.amount': 'Beløp',
  'adv.rpt.col.changeYoy': 'Endring mot i fjor',
  'adv.rpt.col.status': 'Status',
  'adv.rpt.row.income': 'Inntekter',
  'adv.rpt.row.costs': 'Kostnader',
  'adv.rpt.row.notDue': 'Ikke forfalt',
  'adv.rpt.row.current': 'Ikke forfalt',
  'adv.rpt.row.overdue': 'Forfalt',
  'adv.rpt.row.total': 'Sum',
  'adv.rpt.cell.vsPreviousYear': 'mot i fjor',
  'adv.rpt.cell.noBasis': 'Ingen sammenligning',

  'adv.rpt.month.jan': 'Januar',
  'adv.rpt.month.feb': 'Februar',
  'adv.rpt.month.mar': 'Mars',
  'adv.rpt.month.apr': 'April',
  'adv.rpt.month.may': 'Mai',
  'adv.rpt.month.jun': 'Juni',
  'adv.rpt.month.jul': 'Juli',
  'adv.rpt.month.aug': 'August',
  'adv.rpt.month.sep': 'September',
  'adv.rpt.month.oct': 'Oktober',
  'adv.rpt.month.nov': 'November',
  'adv.rpt.month.dec': 'Desember',
  'adv.rpt.certainty.confirmed': 'Bokført',
  'adv.rpt.certainty.expected': 'Inneværende måned',
  'adv.rpt.certainty.uncertain': 'Ikke bokført ennå',

  // ------------------------------------------------------------ Budsjett
  'adv.rpt.budget.intro': 'Bokførte tall for {months} måneder av {year} er sammenlignet med budsjettet for de samme månedene, ikke med hele årets budsjett.',

  // ------------------------------------------------------------ Bilag
  'adv.rpt.vouchers.missing': '{count} bokførte kjøp mangler bilag. Til sammen gjelder det {net} i grunnlag og {vat} i fradragsført merverdiavgift.',

  // ------------------------------------------------------------ Tiltak
  'adv.rpt.action.impact': '{label}: {value}',
  'adv.rpt.priority.high': 'Høy',
  'adv.rpt.priority.medium': 'Middels',
  'adv.rpt.priority.low': 'Lav',
  'adv.rpt.severity.critical': 'Kritisk',
  'adv.rpt.severity.watch': 'Bør følges opp',
  'adv.rpt.severity.info': 'Til informasjon',

  // ------------------------------------------------------------ Beslutninger
  'adv.rpt.decision.risk': 'Ta stilling til: {name}',
  'adv.rpt.decision.opportunity': 'Vurder: {name}',
  'adv.rpt.decision.freeCapital': 'Bestem bruk av ledig kapital på {amount}.',

  // ------------------------------------------------------------ Merknader
  'adv.rpt.note.noPreviousYear': 'Det finnes ingen bokførte tall for {year}, så endring mot fjoråret kan ikke beregnes.',
  'adv.rpt.note.partialYear': 'Perioden er ikke avsluttet. Tallene dekker {months} måneder av {year}.',
  'adv.rpt.note.noMaterialVariance': 'Ingen enkeltlinjer avviker vesentlig fra budsjettet.',
  'adv.rpt.note.unbudgeted': '{count} kontoer har bokførte beløp uten budsjettlinje. De er tatt med i totalen.',
  'adv.rpt.note.belowBuffer': 'Laveste beregnede saldo er {lowest}, under valgt buffermål på {buffer}.',
  'adv.rpt.note.aboveBuffer': 'Den løpende saldoen holder seg over bufferen på {buffer} gjennom hele perioden.',
  'adv.rpt.note.forecastIsBooked': 'Kurven er en løpende saldo av bokførte tall, ikke en prognosemodell. Måneder det ikke er bokført på ennå står flatt.',
  'adv.rpt.note.balanceGrouping': 'Egenkapital og gjeld vises samlet, slik saldobalansen grupperer dem.',
  'adv.rpt.note.balanceInterimBasis': 'Balansegruppene vises slik de er bokført på rapportdatoen. Forskjellen mellom sidene kan omfatte periodens resultat og skal ikke leses som en ferdigstilt årsbalanse.',
  'adv.rpt.note.noCustomerSplit': 'Salget er ikke fordelt per kunde i grunnlaget.',
  'adv.rpt.note.concentration': '{name} står for {pct} % av det fakturerte salget.',
  'adv.rpt.note.customerBasis': 'Betalingstid er målt på fakturaer som faktisk er betalt.',
  'adv.rpt.note.costJump': 'Én eller flere kostnadslinjer har økt mer enn 25 % mot fjoråret.',
  'adv.rpt.note.topFiveOnly': 'Viser de fem største. Resten er med i totalene, men ikke listet.',
  'adv.rpt.note.vouchersComplete': 'Alle bokførte kjøp har bilag.',
  'adv.rpt.note.vouchersRequired': 'Bokføringsloven krever dokumentasjon for hver postering. Manglende bilag bør skaffes før perioden rapporteres.',
  'adv.rpt.note.overdueSales': '{amount} er forfalt fra kunder og bør følges opp.',
  'adv.rpt.note.overduePurchases': '{amount} er forfalt til leverandører.',
  'adv.rpt.note.noRisks': 'Ingen risikoforhold er funnet i de bokførte tallene.',
  'adv.rpt.note.noActions': 'Ingen tiltak anbefales nå.',
  'adv.rpt.note.notAProtocol': 'Dette er beslutningsstøtte og erstatter ikke styreprotokoll. Vedtak fattes av styret.',

  // ------------------------------------------------------------ Tomme tilstander
  'adv.rpt.empty.noBookkeeping': 'Det er ikke bokført inntekter eller kostnader for {year}. Rapporten får tall så snart det finnes bilag.',
  'adv.rpt.empty.noEvents': 'Ingen vesentlige endringer er registrert i perioden.',
  'adv.rpt.empty.noBudget': 'Det finnes ikke noe budsjett for {year}. Legg inn et budsjett for å få avvik i rapporten.',
  'adv.rpt.empty.noLiquidityBasis': 'Ingen åpne kunde- eller leverandørposter, og ingen bokførte bevegelser å bygge saldoen på.',
  'adv.rpt.empty.noForecast': 'Det finnes ikke et avstemt kontantgrunnlag for saldo-kurven.',
  'adv.rpt.empty.noBalance': 'Saldobalansen for {year} er tom.',
  'adv.rpt.empty.noSales': 'Det er ikke bokført fakturert salg for {year}.',
  'adv.rpt.empty.noCustomerHistory': 'For lite kundehistorikk til å måle gjenkjøp og betalingstid.',
  'adv.rpt.empty.noCosts': 'Det er ikke bokført kostnader for {year}.',
  'adv.rpt.empty.noSupplierSplit': 'Kostnadene er ikke fordelt per leverandør i grunnlaget.',
  'adv.rpt.empty.noReceivables': 'Ingen utestående kundeposter.',
  'adv.rpt.empty.noPayables': 'Ingen utestående leverandørposter.',
  'adv.rpt.empty.noDecisions': 'Ingen saker krever beslutning nå.',

  // ------------------------------------------------------------ Datagrunnlag
  'adv.rpt.source.result': 'Resultatregnskap',
  'adv.rpt.source.balance': 'Saldobalanse',
  'adv.rpt.source.openItems': 'Åpne kunde- og leverandørposter',
  'adv.rpt.source.budget': 'Budsjett',
  'adv.rpt.source.bank': 'Bankbevegelser',
  'adv.rpt.source.invoices': 'Kundefakturaer',
  'adv.rpt.source.purchases': 'Leverandørfakturaer',
  'adv.rpt.source.vouchers': 'Bilag',
  'adv.rpt.basis.generated': 'Generert {date}.',
  'adv.rpt.basis.period': 'Perioden dekker {months} måneder av {year}.',
  'adv.rpt.basis.noPreviousYear': 'Ingen bokførte tall for {year} — sammenligning mot fjoråret mangler.',
  'adv.rpt.basis.noBudget': 'Ingen budsjettlinjer for {year}.',
  'adv.rpt.basis.noPartySplit': 'Fordelingen per kunde og leverandør er ufullstendig. Kundeoversikten viser det som kan spores til fakturert salg.',
  'adv.rpt.basis.topFive': 'Kunde- og leverandørlister viser de fem største.',
  'adv.rpt.basis.bookedOnly': 'Regnskapstall kommer fra bokføringen. Buffer er et mål, ikke en bokført saldo. Planlagte betalinger og beregnede nøkkeltall er merket i rapporten.',

  // ------------------------------------------------------------ Monthly report
  'adv.rpt.period.monthShort': '{month}/{year}',
  'adv.rpt.period.vsPreviousMonth': 'mot forrige måned',
  'adv.rpt.monthPicker.title': 'Velg måned for månedsrapporten',
  'adv.rpt.monthPicker.intro': 'Velg én av de siste 24 kalendermånedene. Rapporten bruker bare bokførte tall, budsjett og sammenligninger for den valgte måneden.',
  'adv.rpt.monthPicker.separate': 'Månedsrapporten har et eget månedsvalg og påvirkes ikke av år- eller kvartalsvalget for andre rapporter.',
  'adv.rpt.monthPicker.continue': 'Velg måned',
  'adv.rpt.monthPicker.back': 'Tilbake til rapportmaler',
  'adv.rpt.monthPicker.generate': 'Generer månedsrapport',
  'adv.rpt.sec.monthlyStatus': 'Status for måneden',
  'adv.rpt.sec.monthlyBudget': 'Måneden mot budsjett',
  'adv.rpt.sec.monthlyComparison': 'Samme måned i fjor',
  'adv.rpt.sec.monthlyTrend': 'Utvikling siste 12 måneder',
  'adv.rpt.sec.monthlyInsights': 'Månedens vurdering og neste steg',
  'adv.rpt.empty.noMonthlyBudget': 'Det finnes ikke budsjett for den valgte måneden.',
  'adv.rpt.empty.noMonthlyComparison': 'Det finnes ikke bokførte tall for samme måned i fjor.',
  'adv.rpt.empty.noMonthlyTrend': 'Det finnes ikke bokførte månedstall i tolvmånedersvinduet.',
  'adv.rpt.col.budget': 'Budsjett',
  'adv.rpt.col.variancePct': 'Avvik i %',
  'adv.rpt.row.result': 'Resultat',
  'adv.rpt.chart.monthBudgetActual': 'Budsjett og faktisk for måneden',
  'adv.rpt.chart.sameMonthComparison': 'Valgt måned mot samme måned i fjor',
  'adv.rpt.metric.averageMonthlyResult': 'Snittresultat per måned',
  'adv.rpt.metric.bestMonthlyResult': 'Beste måned',
  'adv.rpt.metric.weakestMonthlyResult': 'Svakeste måned',
  'adv.rpt.monthly.statusProfit': 'Måneden endte med et overskudd på {result} og en resultatmargin på {margin} %.',
  'adv.rpt.monthly.statusLoss': 'Måneden endte med et underskudd på {result} og en resultatmargin på {margin} %.',
  'adv.rpt.monthly.budgetAbove': 'Resultatet er {amount} bedre enn budsjettet for måneden.',
  'adv.rpt.monthly.budgetBelow': 'Resultatet er {amount} svakere enn budsjettet for måneden.',
  'adv.rpt.monthly.marginChange': 'Resultatmarginen er endret med {change} prosentpoeng fra samme måned i fjor.',
  'adv.rpt.monthly.trendBasis': 'Utviklingen viser inntil 12 bokførte kalendermåneder frem til og med den valgte måneden.',
  'adv.rpt.monthly.insightLossTitle': 'Negativt månedsresultat',
  'adv.rpt.monthly.insightLossBody': 'Kostnadene var høyere enn inntektene med {amount} i den valgte måneden.',
  'adv.rpt.monthly.insightProfitTitle': 'Positivt månedsresultat',
  'adv.rpt.monthly.insightProfitBody': 'Måneden ga et overskudd på {amount}. Følg opp hvilke inntekter og kostnader som bør gjentas.',
  'adv.rpt.monthly.insightIncomeDownTitle': 'Lavere inntekter enn i fjor',
  'adv.rpt.monthly.insightIncomeDownBody': 'Inntektene er {change} % lavere enn samme måned i fjor.',
  'adv.rpt.monthly.insightCostsTitle': 'Kostnader over budsjett',
  'adv.rpt.monthly.insightCostsBody': 'Kostnadene er {amount} høyere enn budsjettet for måneden.',
  'adv.rpt.monthly.insightBudgetTitle': 'Resultat bak budsjett',
  'adv.rpt.monthly.insightBudgetBody': 'Resultatet er {amount} svakere enn budsjettet for måneden.',
  'adv.rpt.monthly.stepReviewDrivers': 'Gå gjennom postene som forklarer månedsresultatet, og avklar hva som er varig.',
  'adv.rpt.monthly.stepRevenue': 'Følg opp inntektsfallet mot samme måned i fjor.',
  'adv.rpt.monthly.stepCosts': 'Identifiser kostnadene som ligger over månedsbudsjettet.',
  'adv.rpt.monthly.stepBudget': 'Oppdater tiltakene for å lukke resultatavviket mot månedsbudsjettet.',
  'adv.rpt.monthly.stepContinue': 'Bevar driverne bak det positive månedsresultatet og følg utviklingen neste måned.',
});
